<template>
  <div
    class="SearchBar"
    :class="{ '-expanded': !hidden }"
  >
    <button
      v-if="hidden"
      class="button-unstyled nav-icon"
      :title="$t('nav.search')"
      type="button"
      :aria-expanded="!hidden"
      @click.prevent.stop="toggleHidden"
    >
      <FAIcon
        fixed-width
        class="fa-scale-110 fa-old-padding"
        icon="search"
      />
    </button>
    <SearchField
      v-else
      ref="searchInput"
      v-model="searchTerm"
      v-model:account="account"
      input-id="search-bar-input"
      class="search-bar-field"
      :label="$t('search.bar_label')"
      closable
      @submit="find"
      @close="close"
    />
  </div>
</template>

<script src="./search_bar.js"></script>

<style lang="scss">
.SearchBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;

  /* open: one width, chip or not; narrower when the bar has less room */
  &.-expanded {
    flex: 0 1 22em;
  }

  .search-bar-field {
    flex: 1 1 auto;
  }
}
</style>
